<template>
    <div class="creative">
        <!-- 父级信息 -->
        <div class="panel panel-btn">
            <div
                v-if="status.type == 'creative' && ((status.action == 'add' && !status.id) || status.action == 'copy')"
                class="panel-row"
            >
                <span class="panel-row-label">
                    <span>广告组名称</span>
                    <span v-if="creativeError.campaignId && blur.campaignId" class="panel-row-error">
                        <Icon class="panel-row-error-icon" type="close-circled"></Icon>请选择广告组
                    </span>
                </span>
                <Select
                    v-model="campaignParams.id"
                    @on-change="onCampaignChange"
                    placeholder="请选择广告组"
                    :filterable="true"
                >
                    <Option v-for="item in campaignList" :value="item.id" :key="item.id">{{ item.name }}</Option>
                </Select>
            </div>
            <template v-else>
                <div class="panel-row">
                    <span
                        class="panel-row-label showregular"
                        style="display: block; max-width: 6rem"
                        :class="{ 'no-margin': 1 }"
                        :title="seriesParams.name"
                        >广告系列名称：{{ seriesParams.name }}</span
                    >
                </div>
                <div class="panel-row">
                    <span
                        class="panel-row-label showregular"
                        style="display: block; max-width: 6rem"
                        :class="{ 'no-margin': 1 }"
                        :title="campaignParams.name"
                        >广告组名称：{{ campaignParams.name }}</span
                    >
                </div>
            </template>
        </div>

        <!-- 创意上传 -->
        <div class="panel panel-btn" id="creative">
            <div class="panel-title">创意上传</div>
            <!-- 导航 -->
            <div class="panel-row">
                <Tabs :value="creativeType == 5 ? '2' : creativeType + ''" @on-click="onChangeNavigation">
                    <TabPane
                        v-for="item in navList"
                        :key="item.value"
                        :label="item.label"
                        :disabled="item.value != creativeType && status.action == 'edit' && status.type == 'creative'"
                        :name="item.value"
                    />
                </Tabs>
            </div>
            <!-- 单图 -->
            <ImgCreative v-show="creativeType == 1" :blur="blur.img" />
            <!-- 多尺寸通投 -->
            <Info :info-params.sync="infoParams" v-show="creativeType == 2 || creativeType == 5" />
            <!-- HTML -->
            <HtmlCreative :blur="blur.html" v-show="creativeType == 11" />
            <!-- 动图 -->
            <Banner v-show="creativeType == 4" />
            <!-- 视频 -->
            <VideoCpt :blur="blur.html" v-show="creativeType == 3" />
        </div>

        <!-- 保存 -->
        <div class="panel panel-btn">
            <Button
                v-if="status.type != 'creative'"
                type="default"
                @click="$emit('last-step')"
                size="large"
                style="margin-right: 0.3rem"
                >上一步</Button
            >
            <Button type="primary" @click="onSave" size="large">保存</Button>
        </div>
    </div>
</template>
<script>
import Info from './Info.vue';
import ImgCreative from './ImgCreative.vue';
import HtmlCreative from './HtmlCreative.vue';
import Banner from './Banner.vue';
import VideoCpt from './Video.vue';
import mixins from '@/mixins/index';

export default {
    name: 'Creative',
    mixins: [mixins],
    components: {
        Info,
        ImgCreative,
        HtmlCreative,
        Banner,
        VideoCpt,
    },
    data() {
        return {
            blur: {
                campaignId: false,
                img: {
                    imgUrl: false,
                },
                html: {
                    name: false,
                    h5Url: false,
                },
            },
            // 创意导航
            navList: [
                { label: '多尺寸通投', value: '2' },
                { label: '单图', value: '1' },
                { label: 'HTML', value: '11' },
                { label: '动图', value: '4' },
                { label: '视频', value: '3' },
            ],
            urlQuery: this.mixinGetQueryObject(),
        };
    },
    computed: {
        status() {
            return this.$store.state.newPromotion.status;
        },
        infoParams() {
            return this.$store.state.newPromotion.infoParams;
        },
        seriesParams() {
            return this.$store.state.newPromotion.seriesParams;
        },
        campaignParams() {
            return this.$store.state.newPromotion.campaignParams;
        },
        creativeParams() {
            return this.$store.state.newPromotion.creativeParams;
        },
        creativeError() {
            return this.$store.getters.creativeError;
        },
        campaignList() {
            return this.$store.state.newPromotion.campaignList;
        },
        appList() {
            return this.$store.state.newPromotion.appList;
        },
        infoList() {
            return this.$store.state.newPromotion.infoList;
        },
        imgList() {
            return this.$store.state.newPromotion.imgList;
        },
        videoList() {
            return this.$store.state.newPromotion.videoList;
        },
        bannerList() {
            return this.$store.state.newPromotion.bannerList;
        },
        htmlList() {
            return this.$store.state.newPromotion.htmlList;
        },
        creativeType() {
            return this.$store.state.newPromotion.creativeType;
        },
    },
    created() {
        if (this.status.action != 'add') {
            this.blur = {
                campaignId: true,
                img: {
                    imgUrl: true,
                },
                html: {
                    name: true,
                    h5Url: true,
                },
            };
        }
    },
    methods: {
        /**
         * @desc 选择广告组
         * @param {Number} id 广告组id
         */
        async onCampaignChange(id) {
            const res = await this.$axios.get(this.$port.series.getDetail, { params: { id, type: 2 } });
            const series = res.data.campaignSeries || {};
            this.$store.commit('seriesParams', {
                ...this.seriesParams,
                ...series,
            });
            const campaign = {
                ...this.campaignParams,
                ...res.data.campaign,
            };
            this.$store.commit('campaignParams', campaign);
        },
        /**
         * @desc 创意导航切换
         * @param {String} val: 导航索引值
         */
        onChangeNavigation(val) {
            if (this.urlQuery.type == 'edit') return;
            const campaignParams = this.campaignParams;
            const translate = campaignParams.batch && campaignParams.translate && val != 2 && this.creativeType == 2;
            //翻译提示
            if (translate) {
                this.$Modal.confirm({
                    content: '广告组已选择自动翻译，自动翻译应用于多尺寸通投，是否继续操作？',
                    onOk: () => this.$store.commit('creativeType', val),
                    onCancel: () => {
                        this.$store.commit('creativeType', -1);
                        this.$nextTick(() => this.$store.commit('creativeType', 2));
                    },
                });
            } else {
                this.$store.commit('creativeType', val);
            }
        },
        /**
         * @desc 点击保存
         */
        onSave() {
            this.blur = {
                campaignId: true,
                img: {
                    imgUrl: true,
                },
                html: {
                    name: true,
                    h5Url: true,
                },
            };
            if (this.creativeType == 3) {
                if (
                    this.videoList[0].title === '' ||
                    this.videoList[0].description === '' ||
                    this.videoList[0].imgUrl === '' ||
                    this.videoList[0].videoUrl === ''
                ) {
                    this.$Message.error({ content: '请检查视频参数是否完整', duration: 2 });
                    return;
                }
                this.$store.commit('creativeParams', [this.videoList[0]]);
            }
            if (this.creativeType == 1) this.$store.commit('creativeParams', [...this.imgList]);
            if (this.creativeType == 11) {
                if (this.htmlList[0].h5Type == 2) this.htmlList[0].h5Url = '';
                this.$store.commit('creativeParams', [...this.htmlList]);
            }
            if (this.creativeType == 2 || this.creativeType == 5) {
                if (this.status.action == 'edit' && this.status.type == 'creative') {
                    const infoParams = this.infoParams;
                    try {
                        this.$store.commit('creativeParams', [
                            {
                                creativeType: this.creativeType,
                                name: infoParams.textList[0].name,
                                title: infoParams.textList[0].title,
                                description: infoParams.textList[0].description,
                                buttonText: infoParams.textList[0].buttonText,
                                status: 1,
                                imgUrl: infoParams.imgList[0].imgUrl,
                                sizeType: infoParams.imgList[0].sizeType,
                                iconUrl: infoParams.iconUrl,
                            },
                        ]);
                    } catch (error) {
                        this.$store.commit('creativeParams', []);
                    }
                } else this.$store.commit('creativeParams', [...this.infoList]);
            }
            if (this.creativeType == 4) {
                this.$store.commit('creativeParams', [
                    ...this.bannerList.map((item) => {
                        item.imgUrl = item.imgList
                            .filter((item) => item.imgUrl)
                            .map((item) => item.imgUrl)
                            .join(',');
                        return item;
                    }),
                ]);
            }
            this.$emit('submit');
        },
    },
};
</script>
<style lang="scss">
.creative {
    .panel-row {
        max-width: none;
    }
    .ivu-tabs-tab {
        line-height: 0.4rem;
        font-size: 0.16rem;
    }

    .btn-loading {
        display: flex;
        align-items: center;
        justify-content: center;
        animation: rotate 2s linear infinite;
        margin-right: 0.06rem;
        .loading {
            width: 0.16rem;
            height: 0.16rem;
            background-image: url('../../../assets/img/common/btn_loading.png');
            background-size: 100% auto;
            transform-origin: center center;
        }
    }
    // 删除按钮图标
    .icon-delete {
        font-size: 0.2rem;
        color: #999999;
        cursor: pointer;
    }
    .template {
        .panel-row {
            margin-bottom: 0.2rem;
            padding: 0 0.2rem;
            .panel-row-label {
                font-size: 0.14rem;
            }
        }
        .ivu-input {
            height: auto;
        }

        .template-body {
            width: 6.2rem;
            border: 1px solid #dfe2e5;
            padding-top: 0.3rem;
            border-radius: 0.05rem;
        }
        .template-title {
            display: flex;
            justify-content: space-between;
            padding: 0 0.2rem;
            font-size: 0.16rem;
            margin-bottom: 0.2rem;
        }
        .template-group {
            padding: 0.1rem 0;
            &.space-between {
                display: flex;
                justify-content: space-between;
            }
        }
        .template-group:not(:nth-child(1)) {
            border-top: 1px solid #dfe2e5;
        }
        .template-footer {
            margin-top: 0.3rem;
            padding-top: 0.2rem;
            border-top: 1px solid #e0e0e0;
        }
    }
    //图片上传列表
    .banner-img-list {
        display: flex;
        flex-wrap: wrap;
        .banner-img-item {
            position: relative;
            border: 1px dashed #dfe2e5;
            box-sizing: border-box;
            border-radius: 0.05rem;
            height: 1rem;
            width: 1rem;
            margin-right: 0.1rem;
            margin-bottom: 0.1rem;
            cursor: pointer;
            .item-img-box {
                position: relative;
                height: 100%;
                display: flex;
                align-items: center;
                justify-content: center;
                padding: 0.05rem;
                & > img {
                    max-height: 0.89rem;
                    width: auto;
                    max-width: 0.89rem;
                }
                .img-function {
                    position: absolute;
                    top: 0;
                    bottom: 0;
                    left: 0;
                    right: 0;
                    display: flex;
                    align-items: center;
                    justify-content: space-around;
                    background: rgba($color: #000000, $alpha: 0.4);
                    font-size: 0.24rem;
                    color: #fafafa;
                    // .function-icon {
                    //     margin: 0 0.1rem;
                    // }
                }
            }
            .item-upload {
                height: 100%;
                background: #fafafa;
                display: flex;
                padding-top: 0.32rem;
                flex-direction: column;
                align-items: center;
                box-sizing: border-box;
                &-text {
                    color: #999999;
                    font-size: 0.14rem;
                }
                &-icon {
                    color: #bdbdbd;
                    font-size: 0.24rem;
                    margin-bottom: 0.1rem;
                }
            }
        }
    }
}
@keyframes rotate {
    from {
        transform: rotate(0deg);
    }
    to {
        transform: rotate(360deg);
    }
}
</style>




// WEBPACK FOOTER //
// src/view/NewPromotion/Creative/Creative.vue